(function () {
  if (typeof window.ShambhalaSacredTraditions !== 'undefined') return;

  const ROMAN = ['I', 'II', 'III', 'IV', 'V'];

  class ShambhalaSacredTraditions {
    constructor(root) {
      this.root = root;
      this.navButtons = Array.from(root.querySelectorAll('[data-sst-nav]'));
      this.panels = Array.from(root.querySelectorAll('[data-sst-panel]'));
      this.artifacts = Array.from(root.querySelectorAll('[data-sst-artifact]'));
      this.ambients = Array.from(root.querySelectorAll('[data-sst-ambient]'));
      this.progressDots = Array.from(root.querySelectorAll('[data-sst-progress]'));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.activeIndex = 0;
      this.timer = null;
      this.autoplayMs = parseInt(root.dataset.autoplay || '0', 10) * 1000;

      if (!this.panels.length) return;

      this.bindNav();
      this.bindSwipe();
      this.setActive(0, false);
      this.startAutoplay();
    }

    bindNav() {
      this.navButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.sstNav);
          this.setActive(index, true);
          this.restartAutoplay();
        });
      });
    }

    bindSwipe() {
      const stage = this.root.querySelector('[data-sst-stage]');
      if (!stage || this.panels.length < 2) return;

      let startX = 0;
      let tracking = false;

      stage.addEventListener('touchstart', (e) => {
        startX = e.changedTouches[0].clientX;
        tracking = true;
      }, { passive: true });

      stage.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) < 48) return;

        if (delta < 0) {
          this.setActive((this.activeIndex + 1) % this.panels.length, true);
        } else {
          this.setActive((this.activeIndex - 1 + this.panels.length) % this.panels.length, true);
        }
        this.restartAutoplay();
      }, { passive: true });
    }

    setActive(index, animate) {
      if (index === this.activeIndex && animate) return;
      this.activeIndex = index;

      this.navButtons.forEach((btn, i) => {
        const active = i === index;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.artifacts.forEach((el, i) => el.classList.toggle('is-active', i === index));
      this.ambients.forEach((el, i) => el.classList.toggle('is-active', i === index));

      const badge = this.root.querySelector('[data-sst-index-badge]');
      const label = this.navButtons[index]?.querySelector('.shambhala-sacred-traditions__nav-label')?.textContent?.trim() || '';
      if (badge) {
        badge.textContent = (ROMAN[index] || String(index + 1)) + (label ? ' — ' + label : '');
      }

      this.progressDots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.classList.toggle('is-passed', i < index);
      });
    }

    startAutoplay() {
      if (this.reducedMotion || !this.autoplayMs || this.panels.length < 2) return;
      this.timer = setInterval(() => {
        this.setActive((this.activeIndex + 1) % this.panels.length, true);
      }, this.autoplayMs);
    }

    restartAutoplay() {
      if (this.timer) clearInterval(this.timer);
      this.startAutoplay();
    }
  }

  window.ShambhalaSacredTraditions = ShambhalaSacredTraditions;

  function initAll() {
    document.querySelectorAll('[data-shambhala-sacred-traditions]').forEach((root) => {
      if (root.__sstInstance) return;

      const boot = () => {
        if (root.__sstInstance) return;
        root.__sstInstance = new ShambhalaSacredTraditions(root);
      };

      if (!('IntersectionObserver' in window)) {
        boot();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              boot();
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '160px 0px' }
      );

      observer.observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
